import React from "react";
import styles from "./ProfileAbout.module.css";
import { useAuth } from "../../context/AuthContext";
import { getSocialMediaInfo } from "../../utils/socialMediaUtils";

const ProfileAbout = (props) => {
  console.log(props.profile, "props.profile");
  const { setAuthModal } = useAuth();

  return (
    <div className={styles.blueBorderBlock}>
      <div className={styles.heading}>
        <h4>Profile Details</h4>
      </div>
      <div className={styles.content}>
        <p className={styles.member}>
          Member since
          <span>{props.memberSince}</span>
        </p>
        <p className={styles.location}>
          Location<span>{props.countryName}</span>
        </p>
        {/* <p className={styles.language}>
          Languages<span>English, Hindi, Marathi</span>
        </p> */}
        <p className={styles.time}>
          Availability<span>Available on Weekends</span>
        </p>
        {/* <p className={styles.rate}>
          Hourly rate<span>Not Applicable</span>
        </p> */}

        <div className={styles.academicLinks}>
          Academic Links
          <ul className={styles.academicLinksList}>
            {props?.profile?.academicLinks?.map((item, index) => {
              const socialInfo = getSocialMediaInfo(item);
              if (!socialInfo) return null;
              
              const IconComponent = socialInfo.icon;
              
              return (
                <li key={item}>
                  <a 
                    href={socialInfo.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    title={socialInfo.name}
                    className={styles.academicLink}
                    style={{ color: socialInfo.color }}
                  >
                    <IconComponent size={20} />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={styles.academicLinks}>
          Social Media Links
          <ul className={styles.socialMediaLinks}>
            {props?.profile?.socialMediaLinks?.map((item, index) => {
              const socialInfo = getSocialMediaInfo(item);
              if (!socialInfo) return null;
              
              const IconComponent = socialInfo.icon;
              
              return (
                <li key={item}>
                  <a 
                    href={socialInfo.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    title={socialInfo.name}
                    className={styles.socialMediaLink}
                    style={{ color: socialInfo.color }}
                  >
                    <IconComponent size={20} />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={styles.academicLinks}>
          {props.role === "mentor" ? (
            <button
              onClick={() => setAuthModal({ open: true, tab: "signup" })}
              className={styles.button}
            >
              Become a Mentor
            </button>
          ) : (
            <button
              onClick={() => setAuthModal({ open: true, tab: "signup" })}
              className={styles.button}
            >
              Become a Author
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileAbout;
